var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageLayout',{scopedSlots:_vm._u([{key:"aside",fn:function(){return [_c('MentorSideBar')]},proxy:true},{key:"modals",fn:function(){return [_c('ModalsContainer')]},proxy:true}])},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }